import { FaIcon, faSaveSolid } from '@/lib/fa'
import React from 'react'

const SettingsFooter = ({ loading }) => {
  return (
    <div className="tw-flex tw-w-full tw-items-end tw-justify-end tw-border-t tw-border-gray-300 tw-p-4">
      <button
        disabled={loading}
        type="submit"
        className={`tw-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded-lg tw-bg-primary tw-p-3 tw-text-sm tw-font-medium hover:tw-opacity-80`}
      >
        <FaIcon icon={faSaveSolid} className="tw-text-white" />
        <p className="tw-text-sm tw-font-medium tw-text-white">Zapisz</p>
      </button>
    </div>
  )
}

export default SettingsFooter
